import React, { Suspense } from "react";
import styles from "./PlanLayout.module.css";
import Subnav from "./Subnav";
import Plan, { PlanFallback } from "./Plan";
import { RecurlyPlan } from "@/lib/recurly";
import TextLogo from "@/components/TextLogo/TextLogo";
import Flex from "@/components/Flex/Flex";

export default function PlanLayout({ plan, children }: { plan: RecurlyPlan; children: React.ReactNode }) {
  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <div className={styles.header}>
          <div className={styles.logo}>
            <TextLogo />
          </div>
          <Subnav />
        </div>
        {children}
        <Flex gap={2} justify="center" style={{marginTop:"2rem"}}>
          <span className="small-text">© Boxem</span>
          <span className="small-text">
            <a href="https://www.boxem.com/privacypolicy" target="_blank">Privacy</a>
          </span>
          <span className="small-text">
            <a href="https://www.boxem.com/termsandconditions" target="_blank">Terms</a>
          </span>
        </Flex>
      </main>
      <aside className={styles.aside}>
        <Plan plan={plan} />
      </aside>
    </div>
  );
}
